import axios from 'axios';

export default {
  namespaced: true,
  state: {
    user_slug: null,
  },
  mutations: {
    userSlug(state, response) {
      state.user_slug = response.data.slug;
    },
  },
  actions: {
    getUserInfo({ commit }, payload) {
      const authheader = `Token ${payload}`;
      return axios.get('rest-auth/user/',
        { headers: { Authorization: authheader } })
        .then((response) => {
          commit('userSlug', response);
        })
        .catch(
        );
    },
  },
  getters: {
    user_slug(state) {
      return state.user_slug;
    },
  },
};
